import { gql } from '@apollo/client';

export default gql`
  {
    Animos {
        IdAnimo
        Animo
    }
  }
`;